import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import CustomHomeBuildersHero from './components/CustomHomeBuildersHero';
import CustomHomeBuildersServices from './components/CustomHomeBuildersServices';
import HomeStylesElPaso from './components/HomeStylesElPaso';
import ContractorDirectory from './components/ContractorDirectory';
import ComparisonChecklist from './components/ComparisonChecklist';
import CustomHomeBuildersFAQ from './components/CustomHomeBuildersFAQ';

export default function CustomHomeBuildersPage() {
  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Header />
      <main>
        <CustomHomeBuildersHero />
        <CustomHomeBuildersServices />
        <HomeStylesElPaso />
        <ContractorDirectory />
        <ComparisonChecklist />
        <CustomHomeBuildersFAQ />
      </main>
      <Footer />
    </div>
  );
}
